var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"map-page"},[_c('NavDrawer'),_c('MapView',{ref:"mapView"}),_c('SelectTool'),_c('ToolContainer'),_c('DataContainer'),_c('MapControlsCustom'),_c('ToastNotification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }